import { SelectOptionWithLabel } from 'components/inputs/Input'

export function generateInitialValue<T>(options: SelectOptionWithLabel<T>[], selectedOption: T) {
    return options.find(({ data }) => data === selectedOption) ?? options[0]
}
